import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { PartyPopper } from "lucide-react";

const GRADES = ["Kindergarten", "1st grade", "2nd grade", "3rd grade", "4th grade", "5th grade", "6th grade"];

const POOL = [
  { tier: "General", accent: "#38BDF8", weight: 4 },
  { tier: "Hawk", accent: "#00F5D4", weight: 3 },
  { tier: "Falcon", accent: "#F43F1A", weight: 2 },
  { tier: "Eagle", accent: "#FF007F", weight: 2 },
  { tier: "Pelican", accent: "#D946EF", weight: 1 },
  { tier: "Grandparents", accent: "#F59E0B", weight: 2 },
];

const pickTier = () => {
  const total = POOL.reduce((s, t) => s + t.weight, 0);
  let r = Math.random() * total;
  for (const t of POOL) {
    if ((r -= t.weight) <= 0) return t;
  }
  return POOL[0];
};

const buildJoin = () => {
  const t = pickTier();
  const grade = GRADES[Math.floor(Math.random() * GRADES.length)];
  const message =
    t.tier === "Grandparents"
      ? "A proud Grandparent just joined the flock!"
      : `A ${grade} parent just joined at ${t.tier} level!`;
  return { message, accent: t.accent, key: Date.now() };
};

export const SocialProof = () => {
  const [toast, setToast] = useState(null);

  useEffect(() => {
    let hideTimer;
    let nextTimer;
    const fire = () => {
      const join = buildJoin();
      setToast(join);
      window.dispatchEvent(new CustomEvent("pta-join"));
      hideTimer = setTimeout(() => setToast(null), 6000);
      nextTimer = setTimeout(fire, 25000 + Math.random() * 25000);
    };
    nextTimer = setTimeout(fire, 12000);
    return () => {
      clearTimeout(hideTimer);
      clearTimeout(nextTimer);
    };
  }, []);

  return (
    <div className="fixed bottom-5 left-5 z-[60] pointer-events-none">
      <AnimatePresence>
        {toast && (
          <motion.div
            key={toast.key}
            initial={{ opacity: 0, y: 30, scale: 0.92 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 20, scale: 0.95 }}
            transition={{ duration: 0.45, ease: [0.22, 1, 0.36, 1] }}
            data-testid="social-proof-toast"
            className="flex items-center gap-3 bg-slate-950 text-white rounded-2xl pl-3 pr-5 py-3 border border-slate-700 shadow-2xl max-w-[320px]"
            style={{ boxShadow: `0 0 24px ${toast.accent}55` }}
          >
            <span
              className="w-9 h-9 rounded-full flex items-center justify-center shrink-0"
              style={{ backgroundColor: `${toast.accent}22`, border: `1px solid ${toast.accent}` }}
            >
              <PartyPopper size={16} style={{ color: toast.accent }} />
            </span>
            <span className="text-xs font-semibold leading-snug">
              {toast.message}
              <span className="block text-[10px] font-bold uppercase tracking-wider mt-0.5" style={{ color: toast.accent }}>
                Your membership matters!
              </span>
            </span>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};
